module.exports = {
  "dof-collapse": {
    "position": "relative"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-29091106!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-collapse/index.vue
// module id = 455
// module chunks = 0 1